import { FC } from 'react';
import { Button } from 'components/common';
import { EditIcon } from 'components/common/Icons';
import { DeleteIcon } from 'components/common/Icons/DeleteIcon';
import { ICardProps } from './types';

export const Card: FC<ICardProps> = ({ firstName, lastName, balance, onDelete, onEdit }) => {
  return (
    <div className={'flex flex-col items-center rounded-xl px-5 pt-12 pb-5 shadow-md'}>
      <h3 className={'mt-0 text-xl'}>{`${lastName}, ${firstName}`}</h3>
      <p className={'mt-0 text-base text-gray-500'}>£{balance}</p>
      <div className={'mt-10 flex'}>
        <Button size={'medium'} color={'info'} variant={'text'} onClick={onDelete}>
          <DeleteIcon htmlColor={'grey'} />
        </Button>
        <Button size={'large'} color={'info'} variant={'text'} onClick={onEdit}>
          <EditIcon htmlColor={'grey'} />
        </Button>
      </div>
    </div>
  );
};
